import * as React from 'react';
import IFormError from '../forms/IFormError';
import IInputField from './IInputField';
import { filter } from 'lodash';

interface IProps {
    length?: number,
    maxLength?: number,
    minLength?: number,
    required?: boolean;
    icon?: string;
    placeholder?: string;
    label: string;
    value: string;
    validate?(key: string, value: string, errors: string[], validateInput?: Function): void;
    onChange?(value: any, key: string): void;
    autoComplete?: string,
    allowOnlyDigits?: boolean,
    readonly?: boolean,
    forbidSpecialChars?: boolean,
    tooltip?: string,
    onBlur?: Function,
    saved?: boolean,
    onEnter?: Function
    className?: string,
    inputAdded?: string,
    uid: string,
    serverErrors?: IFormError[]
    onClickInputAdded?(): void,
}

interface IState {
    errors: string[],
}

export default class InputText extends React.Component<IProps, IState> implements IInputField {
    protected input: React.RefObject<HTMLInputElement>;

    constructor(props: IProps) {
        super(props);
        this.input = React.createRef();
        this.state = {
            errors: [],
        };
    }

    focus() {
        this.input.current.focus();
    }

    getErrors(value = this.props.value || '') {
        let errors: string[] = [];

        if (this.props.validate) {
            this.props.validate(
                this.props.uid, value || '',
                errors,
                () => this.validateInput(value, errors),
            );
            if (errors.length !== 0) {
                return errors;
            }
        }

        this.validateInput(value, errors);
        return errors;
    }

    isValid() {
        return this.getErrors().length === 0;
    }

    validate(value = this.props.value || '') {
        this.setState({
            errors: this.getErrors(value),
        })
    }

    validateInput(value: string, errors: string[]) {
        if (this.props.required === false && (this.props.value || '').length === 0) {
            return;
        }

        filter(this.props.serverErrors, error => {
            if (error.key.toLowerCase() === this.props.uid.toLowerCase()) {
                return true;
            }
            return false;
        }).map(error =>  errors.push(error.message))

        if (this.props.required && (value || '').length === 0) {
            errors.push("Toto pole je povinné");
        }
        if (this.props.minLength && (value || '').length < this.props.minLength) {
            errors.push("Zadejte alespoň " + this.props.minLength + " znaků");
        }
        if (this.props.length && (value || '').length !== this.props.length) {
            if ((this.props.required || (value || '').length > 0)) {
                errors.push("Pole musí obsahovat " + this.props.length + " znaků");
            }
        }
        if (this.props.forbidSpecialChars === true && (value || '')) {
            var filterEx = /^[^<>!@$]*$/;

            if (!filterEx.test(value || '')) {
                errors.push("Pole nesmí obsahovat speciální znaky");
            }
        }
        if (this.props.allowOnlyDigits && (value || '').length > 0) {
            var isnum = /^\d+$/.test(value || '');
            if (!isnum) {
                errors.push("Pole může obsahovat pouze číslice");
            }
        }
        if (this.props.maxLength && (value || '').length > this.props.maxLength) {
            errors.push("Pole může obsahovat maximálně " + this.props.maxLength + " znaků");
        }
    }

    handleOnBlur() {
        this.validate();
        if (this.isValid() && this.props.onBlur) {
            this.props.onBlur();
        }

    }

    handleChange(e: any) {
        let value = e.target.value;

        if (this.props.maxLength && (value || '').length > this.props.maxLength) {
            value = value.slice(0, this.props.maxLength);
        }
        this.props.onChange(value, this.props.uid);
        this.setState({
            errors: []
        })
    }

    handleKeyDown(e: React.KeyboardEvent) {
        if (this.props.onEnter && e.key === 'Enter') {
            this.props.onEnter();
        }
    }

    handleClickInputAdded() {
        if (this.props.onClickInputAdded) {
            this.props.onClickInputAdded();
        }
      
    }

    renderError() {
        if (this.state.errors.length === 0) { return null; }
        return (
            <ul className="parsley-errors-list filled" id="parsley-id-5">
                <li className="parsley-required">{this.state.errors[0]}</li>
            </ul>
        )
    }

    renderCountOfChars() {
        if (this.props.maxLength) {
            return (
                <small>
                    Napsáno: {this.props.value != null ? this.props.value.length : 0} (max: {this.props.maxLength} znaků)
                </small>
            );
        }
        return null;
    }

    renderLabel() {
        if (this.props.label.length === 0) {
            return null;
        }

        return (
            <label className="form-control-label">
                {this.props.label} {this.props.required && this.props.label.length !== 0 ? <span className="text-danger">*</span> : null}
            </label>
        );
    }

    render() {
        return (
            <div className="form-group">
                {this.renderLabel()}
                <div className="input-group">
                    <input
                        data-clarity-unmask="True"
                        type="text"
                        ref={this.input}
                        className={`${this.props.className ? this.props.className :'form-control'} ${this.state.errors.length === 0 ? '' : 'parsley-error'}`}
                        placeholder={this.props.placeholder}
                        value={this.props.value || ''}
                        onChange={this.handleChange.bind(this)}
                        autoComplete={this.props.autoComplete}
                        readOnly={this.props.readonly}
                        disabled={this.props.readonly}
                        onBlur={this.handleOnBlur.bind(this)}
                        onKeyDown={this.handleKeyDown.bind(this)}
                    />

                    {this.props.inputAdded &&

                        <div className="input-group-append" onClick={this.handleClickInputAdded.bind(this)}>
                            <span className={`input-group-text ${this.props.onClickInputAdded ? 'clickable' :''}`} id="basic-addon2">{this.props.inputAdded}</span>
                        </div>}

                </div>

                <div className="">
                    {this.renderCountOfChars()}

                    {this.props.saved === true ? <small>
                        <span className="float-right text-right text-success mt-1">
                            <i className={`fas fa-check text-success tx-16 lh-0 op-6`}></i> uloženo</span>
                    </small> : ''}
                </div>

                {this.renderError()}
            </div>
        );
    }
}
